module.exports = __webpack_public_path__ + "img/table-minus.02e750f5.svg";